<!-- v2: plain switch with tooltip on toggle -->
<label *ngIf="!showLabel" class="retrieval-mode-switch switch t-no-arrow t-wrap" [class.t-top]="tooltipOnTop"
  [class.t-bottom]="!tooltipOnTop" [attr.aria-label]="tooltipKey | translate"
  [attr.data-tooltip]="tooltipKey | translate">
  <input type="checkbox" [checked]="allVersionsEnabled" (change)="onToggle($event)" />
  <span class="slider"></span>
</label>

<!-- v3: pill with label + switch + separate info tooltip -->
<div *ngIf="showLabel" class="retrieval-mode-labeled">
  <div class="retrieval-mode-pill">
    <span class="retrieval-mode-pill-label">{{ toggleLabelKey | translate }}</span>
    <label class="retrieval-mode-switch switch" [attr.aria-label]="toggleLabelKey | translate">
      <input type="checkbox" [checked]="allVersionsEnabled" (change)="onToggle($event)" />
      <span class="slider"></span>
    </label>

    <button type="button" class="retrieval-mode-info-btn t-no-arrow t-wrap" [class.t-top]="tooltipOnTop"
      [class.t-bottom]="!tooltipOnTop" [attr.aria-label]="tooltipKey | translate"
      [attr.data-tooltip]="tooltipKey | translate">
      <img src="assets/icons/info-gsk.svg" alt="" aria-hidden="true" class="retrieval-mode-info-icon" />
    </button>
  </div>
</div>